import { Product } from '../types'

export const products: Product[] = [
  {
    id: 'spa',
    name: 'Hydrosprings Spa',
    capacity: '1,200\u20135,000 gallon spa, jacuzzi or cold plunge',
    description:
      'The patented Fusion 44X Hydro-pH-Infusion process balances water to a pH of 7.2\u20137.6, kills algae and bacteria, and holds clarity \u2014 using science, not chemicals.',
    financing: 'Financing available',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4ff8e183-6fa5-4651-bdf1-bec618c35c18.jpg',
  },
  {
    id: 'residential',
    name: 'Hydrosprings Residential',
    capacity: '5,000\u201313,000 gallon pool \u00b7 single unit',
    description:
      'The system most families start with. One unit retrofits into your existing plumbing and takes over balancing, sanitizing and clarity for good.',
    financing: 'Financing available',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c607324b-60f0-4347-9148-bbc4537d8d8b.jpg',
    featured: true,
  },
  {
    id: 'residential-large',
    name: 'Hydrosprings Residential Large',
    capacity: '14,000\u201328,000 gallon pool \u00b7 double unit',
    description:
      'Two paired Fusion 44X units for larger bodies of water, delivering the same drinking-standard clarity across higher volume and heavier bather loads.',
    financing: 'Financing available',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6e5e5147-f913-436b-a830-5cfe937926a1.jpg',
  },
  {
    id: 'commercial',
    name: 'Hydrosprings Commercial',
    capacity: 'Resorts, HOAs, clubs, municipal and therapy pools',
    description:
      'Engineered per site. Text us your gallonage, bather load and current sanitation method and we will size a build and quote it.',
    financing: 'Quoted per site',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/90541a67-11ae-450a-aded-33b3d5afdf9f.jpg',
  },
]
